"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var StatBar = function StatBar(_ref) {
  var stats = _ref.stats,
    percentage = _ref.percentage,
    className = _ref.className;
  var buildMarkupStats = function buildMarkupStats(stats) {
    switch (stats.length) {
      case 2:
        return stats.map(function (item, index) {
          return /*#__PURE__*/_react.default.createElement("div", {
            key: index,
            className: "uk-statbar__stat cell auto text-center"
          }, /*#__PURE__*/_react.default.createElement("strong", null, item.stat, " ", percentage ? '%' : item.percentage ? '%' : null), /*#__PURE__*/_react.default.createElement("h3", null, item.label));
        });
      case 3:
        return stats.map(function (item, index) {
          return /*#__PURE__*/_react.default.createElement("div", {
            key: index,
            className: "uk-statbar__stat cell auto text-center"
          }, /*#__PURE__*/_react.default.createElement("strong", null, item.stat, " ", percentage ? '%' : item.percentage ? '%' : null), /*#__PURE__*/_react.default.createElement("h3", null, item.label));
        });
      case 4:
        return stats.map(function (item, index) {
          return /*#__PURE__*/_react.default.createElement("div", {
            key: index,
            className: "uk-statbar__stat cell auto text-center"
          }, /*#__PURE__*/_react.default.createElement("strong", null, item.stat, " ", percentage ? '%' : item.percentage ? '%' : null), /*#__PURE__*/_react.default.createElement("h3", null, item.label));
        });
      default:
        return stats.map(function (item, index) {
          return /*#__PURE__*/_react.default.createElement("div", {
            key: index,
            className: "uk-statbar__stat cell auto text-center"
          }, /*#__PURE__*/_react.default.createElement("strong", null, item.stat, " ", percentage ? '%' : item.percentage ? '%' : null), /*#__PURE__*/_react.default.createElement("h3", null, item.label));
        });
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, stats.length !== 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-statbar grid-x align-center " + (className || '')
  }, buildMarkupStats(stats)));
};
StatBar.propTypes = {
  /**
   * Take an array of objects of data
   */
  stats: _propTypes.default.any.isRequired,
  /**
   * Percentage by default
   */
  percentage: _propTypes.default.bool
};
StatBar.defaultProps = {
  stats: [],
  percentage: false
};
var _default = StatBar;
exports.default = _default;